import * as React from 'react';
import { loadMoreUGCReviews, setReviewSorting } from '../../../actions/ugcAction';
import { Specials } from '../../../components/Specials/Specials';
import { __ } from '../../../helpers/TranslationService';
import { useTypedSelector } from '../../../hooks/useTypedSelector';
import { CabinTable } from './CabinTable';
import { Inclusives } from './Inclusives';
import { UserGeneratedContentSection } from './UserGeneratedContentSection';
import { config } from '../../../config';

export interface ICruisePriceSection {
    startHarbour?: string;
    endHarbour?: string;
    cheapestCabinId: number;
    onCabinSelection?: (event: any) => void;
    selectedCabinId?: number;
    cabinSectionRef?: React.MutableRefObject<HTMLDivElement> | null;
}

const CruisePriceSection = (props: ICruisePriceSection) => {
    const { pageData, cruisePage, ui, reviews: reviewsData } = useTypedSelector((state) => state);
    const { isLoadingGlobal } = ui;

    if (isLoadingGlobal) return null;
    const { sails, loadingRates } = cruisePage;

    const numberOfReviews = reviewsData?.reviews?.aggregation?.data?.attributes?.numRatings;
    const isDesktop = pageData.deviceType === 'desktop';
    const showCabinTable = !isDesktop && sails.length > 0 && !loadingRates;
    return (
        <div>
            <div className="lineSeparator" />
            {!isDesktop && cruisePage.specials?.length > 0 && (
                <Specials specials={cruisePage.specials as any} />
            )}

            {!isDesktop && Boolean(numberOfReviews) && (
                <UserGeneratedContentSection
                    cruisePage={cruisePage}
                    reviewsData={reviewsData}
                    pageData={pageData}
                    loadMoreUGCReviews={loadMoreUGCReviews}
                    setReviewSorting={setReviewSorting}
                />
            )}
            <div className="cruisePageSection">
                {isDesktop && Boolean(cruisePage.icons?.length) && (
                    <div className="inclusivesWrapper">
                        <h2>{__('Inclusives', 'dreamlines')}</h2>
                        <Inclusives icons={cruisePage.icons} />
                    </div>
                )}
                {loadingRates && (
                    <div className="overview-price-component__placeholder__loading full-width">
                        <img alt="price loading" src={`${config.images}/common/loading.gif`} />
                    </div>
                )}
                {showCabinTable && (
                    <CabinTable
                        cabinSectionRef={props.cabinSectionRef}
                        cheapestCabinId={props.cheapestCabinId}
                        onCabinSelection={(e) => props.onCabinSelection(e)}
                        selectedCabinId={props.selectedCabinId}
                    />
                )}
            </div>
        </div>
    );
};
export default CruisePriceSection;
